var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBenqi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.787 23.112C21.4601 23.112 13.8991 30.673 13.8991 39.9999C13.8991 49.2975 21.4124 56.8401 30.6987 56.8877L35.3803 67.4883C33.886 67.7362 32.3516 67.8651 30.787 67.8651C15.3975 67.8651 2.92188 55.3894 2.92188 39.9999C2.92188 24.6104 15.3975 12.1348 30.787 12.1348C46.1766 12.1348 58.6522 24.6104 58.6522 39.9999C58.6522 46.1088 56.6864 51.7585 53.353 56.351L47.4229 42.9235C47.5886 41.9738 47.675 40.997 47.675 39.9999C47.675 30.673 40.114 23.112 30.787 23.112ZM78.0687 36.6223H65.4027V67.4429H78.0687V36.6223Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.5261 24.7952C66.2438 25.3082 65.403 26.5502 65.403 27.9313V32.8219L76.0343 28.215C77.2695 27.6797 78.0689 26.4621 78.0689 25.1159V20.5781L67.5261 24.7952ZM33.3191 50.1321H45.3518L53.3736 67.8645H41.1298L33.3191 50.1321Z",
    fill: "#00B3ED"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenqi);
export default __webpack_public_path__ + "static/media/benqi.d3769ed2d70ebf7b4a78eae725353d34.svg";
export { ForwardRef as ReactComponent };